import { c as _c } from "react/compiler-runtime";
import { ReactElement, memo, useContext } from 'react';
import BazaarvoiceReviewStarsComponent from './bazaarvoice-review-stars.component';
import ButtonComponent from '@spa/components/button/button/button.component';
import { ButtonType } from '@spa/components/button/types/ButtonType';
import { LocaleContext } from '@spa/lib/react/context/LocaleContext';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { ProductReviewOverview } from '@spa/generated/graphql/graphql';
import formatRatingValue from '@spa/lib/formatRatingValue';
import getRoundedStarRating from '@spa/lib/getRoundedStarRating';
import styles from './bazaarvoice-review-overview.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly overview: ProductReviewOverview;
  readonly onWriteReviewClick: () => void;
}
function BazaarvoiceReviewOverviewComponent(t0) {
  const $ = _c(80);
  const {
    overview,
    onWriteReviewClick
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("bazaarvoice-review-section");
  const locale = useContext(LocaleContext);
  const {
    aggregateRating,
    totalReviewCount,
    ratingDistribution,
    recommendationSummary
  } = overview;
  let t1;
  if ($[0] !== ratingDistribution) {
    t1 = Math.max(1, ...ratingDistribution.map(_temp));
    $[0] = ratingDistribution;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const maxDistributionCount = t1;
  const totalRecommendationVotes = recommendationSummary.recommendedCount + recommendationSummary.notRecommendedCount;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[2] !== aggregateRating || $[3] !== formatMessage || $[4] !== locale || $[5] !== maxDistributionCount || $[6] !== ratingDistribution || $[7] !== recommendationSummary.recommendedCount || $[8] !== totalRecommendationVotes || $[9] !== totalReviewCount) {
    const recommendedPercentage = totalRecommendationVotes > 0 ? Math.round(recommendationSummary.recommendedCount / totalRecommendationVotes * 100) : null;
    let filledStars;
    let formattedAggregateRating;
    let hasHalfStar;
    let t10;
    let t11;
    let t9;
    if ($[17] !== aggregateRating || $[18] !== formatMessage || $[19] !== locale || $[20] !== maxDistributionCount || $[21] !== ratingDistribution || $[22] !== totalReviewCount) {
      const sortedDistribution = [...ratingDistribution].sort(_temp2);
      const roundedRating = getRoundedStarRating(aggregateRating);
      filledStars = Math.floor(roundedRating);
      hasHalfStar = roundedRating - filledStars === 0.5;
      formattedAggregateRating = formatRatingValue(aggregateRating, locale);
      t8 = styles["bazaarvoice-review-overview"];
      t6 = styles["bazaarvoice-review-overview__wrapper"];
      let t12;
      if ($[34] !== formatMessage || $[35] !== maxDistributionCount) {
        t12 = t13 => {
          const {
            rating,
            count: count_0
          } = t13;
          return <div key={rating} className={styles["bazaarvoice-review-overview__distribution-row"]}><span className={styles["bazaarvoice-review-overview__distribution-label"]}>{formatMessage(`starDistributionLabel.${rating}`)}</span><span className={styles["bazaarvoice-review-overview__distribution-bar-track"]} aria-hidden={true}><span className={styles["bazaarvoice-review-overview__distribution-bar-fill"]} style={{
                width: `${count_0 / maxDistributionCount * 100}%`
              }} /></span><span className={styles["bazaarvoice-review-overview__distribution-count"]}>{count_0}</span></div>;
        };
        $[34] = formatMessage;
        $[35] = maxDistributionCount;
        $[36] = t12;
      } else {
        t12 = $[36];
      }
      const t13 = sortedDistribution.map(t12);
      if ($[37] !== t13) {
        t7 = <div className={styles["bazaarvoice-review-overview__distribution"]}>{t13}</div>;
        $[37] = t13;
        $[38] = t7;
      } else {
        t7 = $[38];
      }
      t2 = styles["bazaarvoice-review-overview__aggregate"];
      let t14;
      if ($[39] !== formatMessage) {
        t14 = formatMessage("aggregateRatingHeadline");
        $[39] = formatMessage;
        $[40] = t14;
      } else {
        t14 = $[40];
      }
      if ($[41] !== t14) {
        t3 = <h3 className={styles["bazaarvoice-review-overview__aggregate-headline"]}>{t14}</h3>;
        $[41] = t14;
        $[42] = t3;
      } else {
        t3 = $[42];
      }
      t9 = styles["bazaarvoice-review-overview__aggregate-value-row"];
      t10 = "img";
      t11 = formatMessage("aggregateRatingAriaLabel", {
        rating: formattedAggregateRating,
        totalReviewCount
      });
      $[17] = aggregateRating;
      $[18] = formatMessage;
      $[19] = locale;
      $[20] = maxDistributionCount;
      $[21] = ratingDistribution;
      $[22] = totalReviewCount;
      $[23] = filledStars;
      $[24] = formattedAggregateRating;
      $[25] = hasHalfStar;
      $[26] = t10;
      $[27] = t11;
      $[28] = t2;
      $[29] = t3;
      $[30] = t6;
      $[31] = t7;
      $[32] = t8;
      $[33] = t9;
    } else {
      filledStars = $[23];
      formattedAggregateRating = $[24];
      hasHalfStar = $[25];
      t10 = $[26];
      t11 = $[27];
      t2 = $[28];
      t3 = $[29];
      t6 = $[30];
      t7 = $[31];
      t8 = $[32];
      t9 = $[33];
    }
    let t12;
    if ($[43] !== formattedAggregateRating) {
      t12 = <span className={styles["bazaarvoice-review-overview__aggregate-value"]}>{formattedAggregateRating}</span>;
      $[43] = formattedAggregateRating;
      $[44] = t12;
    } else {
      t12 = $[44];
    }
    let t13;
    if ($[45] !== filledStars || $[46] !== hasHalfStar) {
      t13 = <span className={styles["bazaarvoice-review-overview__aggregate-stars"]}><BazaarvoiceReviewStarsComponent filledStars={filledStars} hasHalfStar={hasHalfStar} starClassName={styles["bazaarvoice-review-overview__aggregate-star"]} /></span>;
      $[45] = filledStars;
      $[46] = hasHalfStar;
      $[47] = t13;
    } else {
      t13 = $[47];
    }
    let t14;
    if ($[48] !== formatMessage || $[49] !== totalReviewCount) {
      t14 = formatMessage("totalReviewCountLink", {
        totalReviewCount
      });
      $[48] = formatMessage;
      $[49] = totalReviewCount;
      $[50] = t14;
    } else {
      t14 = $[50];
    }
    let t15;
    if ($[51] !== t14) {
      t15 = <span className={styles["bazaarvoice-review-overview__aggregate-count-link"]}>{t14}</span>;
      $[51] = t14;
      $[52] = t15;
    } else {
      t15 = $[52];
    }
    let t16;
    if ($[53] !== t13 || $[54] !== t15) {
      t16 = <span className={styles["bazaarvoice-review-overview__aggregate-stars-count"]}>{t13}{t15}</span>;
      $[53] = t13;
      $[54] = t15;
      $[55] = t16;
    } else {
      t16 = $[55];
    }
    if ($[56] !== t10 || $[57] !== t11 || $[58] !== t12 || $[59] !== t16 || $[60] !== t9) {
      t4 = <div className={t9} role={t10} aria-label={t11}>{t12}{t16}</div>;
      $[56] = t10;
      $[57] = t11;
      $[58] = t12;
      $[59] = t16;
      $[60] = t9;
      $[61] = t4;
    } else {
      t4 = $[61];
    }
    t5 = recommendedPercentage !== null && <p className={styles["bazaarvoice-review-overview__recommendation-summary"]}>{formatMessage("recommendationSummary", {
        recommendedCount: recommendationSummary.recommendedCount,
        totalRecommendationVotes,
        recommendedPercentage
      })}</p>;
    $[2] = aggregateRating;
    $[3] = formatMessage;
    $[4] = locale;
    $[5] = maxDistributionCount;
    $[6] = ratingDistribution;
    $[7] = recommendationSummary.recommendedCount;
    $[8] = totalRecommendationVotes;
    $[9] = totalReviewCount;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
  }
  let t9;
  if ($[62] !== t2 || $[63] !== t3 || $[64] !== t4 || $[65] !== t5) {
    t9 = <div className={t2}>{t3}{t4}{t5}</div>;
    $[62] = t2;
    $[63] = t3;
    $[64] = t4;
    $[65] = t5;
    $[66] = t9;
  } else {
    t9 = $[66];
  }
  let t10;
  if ($[67] !== t6 || $[68] !== t7 || $[69] !== t9) {
    t10 = <div className={t6}>{t7}{t9}</div>;
    $[67] = t6;
    $[68] = t7;
    $[69] = t9;
    $[70] = t10;
  } else {
    t10 = $[70];
  }
  let t11;
  if ($[71] !== formatMessage) {
    t11 = formatMessage("writeReviewCta");
    $[71] = formatMessage;
    $[72] = t11;
  } else {
    t11 = $[72];
  }
  let t12;
  if ($[73] !== onWriteReviewClick || $[74] !== t11) {
    t12 = <div className={styles["bazaarvoice-review-overview__add-review"]}><ButtonComponent buttonType={ButtonType.SECONDARY} text={t11} type="button" onClick={onWriteReviewClick} /></div>;
    $[73] = onWriteReviewClick;
    $[74] = t11;
    $[75] = t12;
  } else {
    t12 = $[75];
  }
  let t13;
  if ($[76] !== t10 || $[77] !== t12 || $[78] !== t8) {
    t13 = <div className={t8}>{t10}{t12}</div>;
    $[76] = t10;
    $[77] = t12;
    $[78] = t8;
    $[79] = t13;
  } else {
    t13 = $[79];
  }
  return t13;
}
function _temp2(a, b) {
  return b.rating - a.rating;
}
function _temp(t0) {
  const {
    count
  } = t0;
  return count;
}
export default memo(BazaarvoiceReviewOverviewComponent);